import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import instance from './utils/request.js' // 请求拦截器
Vue.prototype.$http = instance

import Qs from 'qs';
Vue.prototype.qs = Qs;

import * as socketApi from './js/socket.js';
Vue.prototype.socketApi = socketApi;

import Vuex from 'vuex';
Vue.use(Vuex)

Vue.use(ElementUI);
Vue.use(VueAxios, axios);
Vue.config.productionTip = false


// 路由守卫
router.beforeEach((to, from, next) => {
	next();
})

const store = new Vuex.Store({
	state: {},
	getters: {},
	mutations: {},
	actions: {
		wsLogin(context, agentData) {
			console.log('websocket连接成功，用户登录')
			let connectFailed = setTimeout(() => {
				if (context.state.loginStates == '连接超时') {
					console.log('连接超时 -- ', socketApi)
					alert('连接超时')
					socketApi.closeWebSocket()
					context.state.loginStates = '连接超时'
					//					router.go(0)
					router.push({
						path: '/login'
					})
				}
			}, 40 * 1000)
			socketApi.sendSock(agentData, (e) => {
				console.log('wulawula', e)
				clearTimeout(connectFailed)
				if (e.cmd == 'ma_login') {
					if (e.status) {
						context.state.loginStates = '连接超时'
						socketApi.startHeartBeat()
					} else {
						router.push({
							path: '/login'
						})
						localStorage.removeItem('token')
						//登录失败
						if (e.msg == '已经登陆！') {
							context.state.loginStates = '连接超时'
							socketApi.startHeartBeat()
						} else {
							socketApi.closeWebSocket()
							context.state.loginStates = '连接超时'
							alert(store.state.e_msg === 'en' ? e.msg_en : e.msg)
							
						}
					}
				}
			})
		},
	}
});


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')